import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { adminKeys } from "@/lib/query-keys";
import type { AdminUser } from "@/types/domain";

/** Listado de usuarios para el panel de administración (estado beta + plan). */
export function useAdminUsers(enabled = true) {
  return useQuery({
    queryKey: adminKeys.users,
    enabled,
    queryFn: async () => {
      const res = await fetchToBackend<any>("/admin/users");
      return (res?.data ?? res ?? []) as AdminUser[];
    },
  });
}
